import { ProductImageModel } from './productImageModel';
import { ActionHistoryModel } from './actionHistoryModel';
import { LocationSyncModel } from './locationSyncModel';
import { ClientSyncModel } from './clientSyncModel';
import { OfferSyncModel } from './offerSyncModel';
import { CategoryModel } from './../category/categoryModel';
import { ProductModel } from './../product/productModel';

class SynchronizationModel {
    products: Array<ProductModel>;
    categories: Array<CategoryModel>;
    offers: Array<OfferSyncModel>;
    clients: Array<ClientSyncModel>;
    locations: Array<LocationSyncModel>;
    actionHistory: Array<ActionHistoryModel>;
    productImages: Array<ProductImageModel>;
    lastSyncDate: string;
    offersCount: number;
}

export default SynchronizationModel;